import { allowanceQueryKey } from '../../approve/logic/query'
import { StakeAction } from '../types'
import { stakingRewardsAbi } from '@/config/abis/stakingRewardsAbi'
import { SPARK_UI_REFERRAL_CODE } from '@/config/consts'
import { trackTransactionConfirmation } from '@/domain/analytics/cookie3'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkFarmDataQueryKey } from '@/features/spk/farm/data/useSpkFarmData'

export function createStakeActionConfig(action: StakeAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      const { stakingToken, farm } = action
      const amount = stakingToken.toBigInt(action.stakeAmount)

      return ensureConfigTypes({
        address: farm,
        abi: stakingRewardsAbi,
        functionName: 'stake',
        args: [amount, SPARK_UI_REFERRAL_CODE],
      })
    },

    invalidates: () => {
      return [
        allowanceQueryKey({ token: action.stakingToken.address, spender: action.farm, account, chainId }),
        getBalancesQueryKeyPrefix({ account, chainId }),
        spkFarmDataQueryKey({ account, chainId }),
      ]
    },

    onSuccessfulAction: () => {
      if (action.stakingToken.symbol === 'USDS' && action.rewardToken.symbol === 'SPK') {
        trackTransactionConfirmation({
          name: 'farm_deposit',
          value: action.stakingToken.toUSD(action.stakeAmount).toNumber(),
          isInSandbox: Boolean(context.isInSandbox),
        })
      }
    },
  }
}
